import { CasEntityRHFSelect, CasEntitySelectProps } from 'src/compass/shared/components';

export default function RHFAgencySelect(props: CasEntitySelectProps) {
  return CasEntityRHFSelect('Ins/Agency/Select', props);
}
